import React from "react";

interface Action {
  label: string;
  icon: React.ReactNode;
  accent: "blue" | "fuchsia" | "green" | "orange" | "slate";
  onClick: () => void;
}

const ACCENT_BG = {
  blue:    "bg-blue-500",
  fuchsia: "bg-fuchsia-500",
  green:   "bg-green-500",
  orange:  "bg-orange-500",
  slate:   "bg-slate-500",
};

interface Props { actions: Action[]; }

export const QuickActions: React.FC<Props> = ({ actions }) => (
  <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
    <h3 className="text-sm font-semibold text-slate-900 mb-4">Quick Actions</h3>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {actions.map((a) => (
        <button
          key={a.label}
          onClick={a.onClick}
          className="flex flex-col items-center justify-center gap-2 rounded-xl border border-slate-100 bg-slate-50 hover:bg-slate-100 transition-colors py-5 px-3"
        >
          <span className={`flex h-10 w-10 items-center justify-center rounded-xl text-white ${ACCENT_BG[a.accent]}`}>
            {a.icon}
          </span>
          <span className="text-xs font-medium text-slate-700">{a.label}</span>
        </button>
      ))}
    </div>
  </div>
);

export default QuickActions;
